import { add, remove, qs, listen } from "@fluorescent/dom";
import srraf from "srraf";
import { switchImage } from "@/utils";

export default function (container) {
  const classes = {
    hidden: "hidden",
  };

  const selectors = {
    buyButtons: ".product-form__item--submit",
    changeOptionButton: "[data-change-option-trigger]",
    imageWrap: ".product__media",
    optionValues: ".sticky-atc-bar__meta-options",
    pageFooter: "footer",
    stickyAtcBar: ".sticky-atc-bar",
    variantSelector: ".product__variants-wrapper",
  };

  const elements = {
    buyButtons: qs(selectors.buyButtons, container),
    pageFooter: qs(selectors.pageFooter, document),
    stickyAtcBar: qs(selectors.stickyAtcBar, container),
    variantSelector: qs(selectors.variantSelector, container),
  };

  if (elements.stickyAtcBar == null) return;

  elements.imageWrap = qs(selectors.imageWrap, elements.stickyAtcBar);
  elements.optionValues = qs(selectors.optionValues, elements.stickyAtcBar);
  elements.changeOptionButton = qs(
    selectors.changeOptionButton,
    elements.stickyAtcBar
  );

  const events = [];

  if (elements.changeOptionButton) {
    events.push(
      listen(elements.changeOptionButton, "click", () =>
        scrollToVariantSelector()
      )
    );
  }

  let widthWatcher;

  const buyButtonsObserver = new IntersectionObserver(
    ([{ isIntersecting: visible }]) => {
      if (visible) {
        hideBar();
      } else {
        showBar();
      }
    }
  );

  const footerObserver = new IntersectionObserver(
    ([{ isIntersecting: visible }]) => {
      if (visible) {
        buyButtonsObserver.disconnect();
        hideBar();
      } else {
        buyButtonsObserver.observe(elements.buyButtons);
      }
    },
    { threshold: 0.8 }
  );

  footerObserver.observe(elements.pageFooter);

  const showBar = () => {
    remove(elements.stickyAtcBar, classes.hidden);
    setHeightVariable();

    widthWatcher = srraf(({ pvw, vw }) => {
      if (pvw !== vw) {
        setHeightVariable();
      }
    });
  };

  const hideBar = () => {
    add(elements.stickyAtcBar, classes.hidden);
    widthWatcher?.destroy();
    clearHeightVariable();
  };

  const setHeightVariable = () => {
    document.documentElement.style.setProperty(
      "--sticky-atc-bar-height",
      `${elements.stickyAtcBar.offsetHeight}px`
    );
  };

  const clearHeightVariable = () => {
    document.documentElement.style.setProperty(
      "--sticky-atc-bar-height",
      "0px"
    );
  };

  const scrollToVariantSelector = () => {
    elements.variantSelector.scrollIntoView({
      block: "center",
      behavior: "smooth",
    });
  };

  const switchCurrentImage = id => {
    switchImage(elements.imageWrap, id);
  };

  const updateOptionValues = variant => {
    const optionValueString = variant.options.join(", ");
    elements.optionValues.textContent = optionValueString;
  };

  const unload = () => {
    buyButtonsObserver?.disconnect();
    events.forEach(unsubscribe => unsubscribe());
    footerObserver?.disconnect();
    widthWatcher?.destroy();
  };

  return { switchCurrentImage, unload, updateOptionValues };
}
